'use strict';

;(function () {
  let goBackButtons, iframeVideos; // DOM
  let windowResizeTimeout;
  const IFRAME_VIDEOS_ASPECT_RATIO = 9 / 16; // 16/9

  function recalculateIframeVideosAspectRatio(){
    iframeVideos.forEach(iframeVideo => {
      iframeVideo.style.height = iframeVideo.offsetWidth * IFRAME_VIDEOS_ASPECT_RATIO + 'px'
    });
  }

  // Events

  function onDocumentLoaded(){
    goBackButtons = document.querySelectorAll('.go-back-btn');
    iframeVideos = document.querySelectorAll('iframe[allow="autoplay"]');

    goBackButtons.forEach((btn) => {
      btn.addEventListener('click', goBackBtnOnClick);
    })

    window.addEventListener('resize', () => {
      clearTimeout(windowResizeTimeout);
      windowResizeTimeout = setTimeout(recalculateIframeVideosAspectRatio, 50);
    });

    recalculateIframeVideosAspectRatio();
  }
  
  function goBackBtnOnClick(e){
    const urlParams = new URLSearchParams(window.location.search);
    const categoryFilter = urlParams.get('category');
    let newUrl = '/blogs/the-blog';

    if(categoryFilter){
      newUrl += '/tagged/' + categoryFilter;
    }

    window.location.href = newUrl;
  }
  
  if(document.readyState != 'loading'){
    onDocumentLoaded();
  } else {
    document.addEventListener("DOMContentLoaded", onDocumentLoaded);
  }
})();